import useEmblaCarousel from "embla-carousel-react";
import AutoScroll from "embla-carousel-auto-scroll";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { THUMBNAILS } from "@/data/portfolio";

export default function Thumbnails() {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, align: "start", containScroll: false, dragFree: true },
    [AutoScroll({ speed: 1, startDelay: 0, stopOnInteraction: false, stopOnMouseEnter: true, stopOnFocusIn: true })]
  );
  const scrollPrev = () => emblaApi && emblaApi.scrollPrev();
  const scrollNext = () => emblaApi && emblaApi.scrollNext();

  return (
    <section id="thumbnails" data-testid="thumbnails-section" className="border-b border-white/10 py-10 md:py-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-5 md:mb-8">
          <div>
            <h2 className="mt-3 font-oswald uppercase text-4xl md:text-6xl lg:text-7xl font-bold leading-[0.95]">
              Click-worthy <span className="font-cormorant italic font-medium normal-case lowercase text-white/70">thumbnails</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md text-sm md:text-base">
            Custom thumbnails designed for the reaction-content algorithm — bold faces, clear titles, sharp composition.
          </p>
        </div>

        <div className="relative">
          <div className="overflow-hidden" ref={emblaRef}>
            <div className="flex gap-4 md:gap-6">
              {THUMBNAILS.map((t, i) => (
                <div
                  key={t.src}
                  data-testid={`thumbnail-slide-${i}`}
                  className="relative shrink-0 basis-[85%] sm:basis-[60%] md:basis-[48%] lg:basis-[38%] aspect-video overflow-hidden border border-white/10 bg-[#070707] group"
                >
                  <img
                    src={t.src}
                    alt={t.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                  <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all">
                    <p className="font-oswald uppercase text-xs tracking-widest text-[#00A0E4]">Thumbnail</p>
                    <p className="font-cormorant italic text-lg text-white">{t.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-8 flex items-center justify-between gap-4">
            <p className="font-oswald uppercase text-xs tracking-widest text-white/40">
              Scrolling · Hover to pause
            </p>
            <div className="flex items-center gap-3">
              <button
                onClick={scrollPrev}
                data-testid="thumbnails-prev"
                aria-label="Previous thumbnail"
                className="w-11 h-11 flex items-center justify-center border border-white/20 hover:border-[#00A0E4] hover:text-[#00A0E4] text-white transition-colors"
              >
                <ChevronLeft size={20} />
              </button>
              <button
                onClick={scrollNext}
                data-testid="thumbnails-next"
                aria-label="Next thumbnail"
                className="w-11 h-11 flex items-center justify-center border border-white/20 hover:border-[#00A0E4] hover:text-[#00A0E4] text-white transition-colors"
              >
                <ChevronRight size={20} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
